import { useEffect, useState } from 'react';
import type { Project, ProjectGroup } from '@/deploy/types';
import { projectsService } from '@/deploy/services/projects.service';
import { gameGroupsEnabled } from '@/deploy/utils/apiInstances';

/**
 * Groupes de jeu du projet, relus au CICD (une modification faite dans Settings est vue sans
 * recharger). NationsGlory seulement : ailleurs (Paladium), `enabled` est faux, `groups` null et
 * aucune requête ne part. Avant la réponse, ou si elle échoue, ce sont les groupes de la session ;
 * null si elle n'en a pas (CICD plus ancien) : la page ne tire alors aucune conclusion.
 */
export function useProjectGameGroups(
  project: Pick<Project, 'id' | 'gameGroupsEnabled' | 'groups'>,
): { enabled: boolean; groups: ProjectGroup[] | null } {
  const enabled = gameGroupsEnabled(project);
  const [loaded, setLoaded] = useState<{ projectId: string; groups: ProjectGroup[] } | null>(null);

  useEffect(() => {
    if (!enabled || !project.id) return;
    let alive = true;
    projectsService.getGroups(project.id)
      .then((g) => { if (alive) setLoaded({ projectId: project.id, groups: Array.isArray(g) ? g : [] }); })
      .catch(() => { /* garde les groupes de la session */ });
    return () => { alive = false; };
  }, [project.id, enabled]);

  if (!enabled) return { enabled, groups: null };
  if (loaded && loaded.projectId === project.id) return { enabled, groups: loaded.groups };
  return { enabled, groups: project.groups ?? null };
}
